import { isRejected } from '@reduxjs/toolkit'

import * as businessDomainActions from 'apps/email/actions/businessDomainActions'
import {
  NodePreloadRulePayload,
  PreloaderRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { INode } from 'common/builder/nodes/nodeInterfaces'
import { GlobalFieldsActions } from 'common/fields/store/globalFields'
import * as filtersActions from 'common/filter/actions/filtersActions'

/**
 * Loads common required data for all nodes
 */
export const CommonRequiredDataNodeGenericPreloaderRule: PreloaderRule<
  INode,
  NodePreloadRulePayload
> = {
  predicate: () => true,

  getKey: () => 'common_required_data',

  createLoader:
    (_, { dispatch }) =>
    () =>
      Promise.all([
        // rtk isRejected on fail
        dispatch(GlobalFieldsActions.getListFx({ payload: { query: { active_only: true } } })),
        // throws error on fail
        dispatch(filtersActions.fetchFilterFields({ allowUserId: true })),
        // throws error on fail
        dispatch(businessDomainActions.fetchBusinessEmails(true)),
      ])
        .then(([globalFieldsResult]) => {
          if (isRejected(globalFieldsResult)) {
            return false
          }

          return true
        })
        .catch(() => false),
}
